import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09a3a57a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { IonAvatar, IonButton, IonButtons, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon, IonItem, IonLabel, IonList, IonContent, IonHeader, IonNote, IonPage, IonTitle, IonToolbar, modalController } from '@ionic/vue'
import { createOutline } from 'ionicons/icons'

import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { useEventStore } from '@/store/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventInfoTab',
  setup(__props) {

const $store = useEventStore()

function alertAppVersion () {
  CapacitorUpdater.current().then(cap => alert(`Verze aplikace: ${process.env.VUE_APP_BUILD_DATETIME} / bundle: ${cap.bundle.version}, ${cap.bundle.status} / native: ${cap.native}`))
}

async function editPage () {
  const InfoTabForm = await import('@/components/InfoTabForm.vue')
  return (await modalController.create({
    component: InfoTabForm.default,
    ...InfoTabForm.modalOptions
  })).present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), {
        collapse: "fade",
        translucent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Info")
                ]),
                _: 1
              }),
              (_unref($store).currentMember?.canWrite)
                ? (_openBlock(), _createBlock(_unref(IonButtons), {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        fill: "clear",
                        size: "small",
                        onClick: editPage
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(createOutline)
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Info")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            innerHTML: _unref($store).event?.infoTab?.content
          }, null, 8, _hoisted_1),
          false
            ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle)),
                      _createVNode(_unref(IonCardSubtitle))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonAvatar)),
                          _createVNode(_unref(IonLabel)),
                          _createVNode(_unref(IonNote))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "app_version_tilde",
            onClick: alertAppVersion
          }, "~")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})